import ChargeBrandListView from '../../components/ChargeBrandListView';

function ChargeBrandListScreen(props) {
  return <ChargeBrandListView showFullUI={true} />;
}

export default ChargeBrandListScreen;
